import Vue from 'vue'
import Child from './Child'

import SelectExtended from './form/SelectExtended'
import TableExtended from './TableExtended'
import VField from './form/VField'
import VHasMany from './form/VHasMany'
import VCheckbox from './form/VCheckbox'
import VDisplay from './form/VDisplay'
import VLastOrder from './form/VLastOrder'
import VDiff from './form/VDiff'
import VInput from './form/VInput'
import VFile from './form/VFile'
import VImage from './form/VImage'
import VMinimumStockAlert from './form/VMinimumStockAlert'
import VSelect from './form/VSelect'
import VSelectPos from './form/VSelectPos'
import VDisplayList from './form/VDisplayList'
import VSelectLendingKitModel from './form/VSelectLendingKitModel'
import VRadio from './form/VRadio'
import VRadioButtons from './form/VRadioButtons'
import VCoords from './form/VCoords'
import VDatetime from './form/VDatetime'
import VAutocomplete from './form/VAutocomplete'
import VAutocompleteList from './form/VAutocompleteList'
import VStockOrderChangeStatus from './form/VStockOrderChangeStatus'
import VButton from './form/VButton'
import VSubmit from './form/VSubmit'
import SpinnerIqos from './spinner/Spinner-Iqos'
import Page from './Page'
import Card from './Card'
import Tabs from './Tabs'
import Alert from './Alert'
import List from './List'
import Header from './Header'
import ChartWidget from './ChartWidget'
import VTable from './Table'
import PhoneValidation from './PhoneValidation'
import LendingKitEdit from './LendingKitEdit'

// Components that are registered globaly.
[
    SelectExtended,
    TableExtended,
    VField,
    VHasMany,
    VCheckbox,
    VDisplay,
    VDisplayList,
    VLastOrder,
    VDiff,
    VInput,
    VFile,
    VImage,
    VMinimumStockAlert,
    VSelect,
    VSelectPos,
    VSelectLendingKitModel,
    VRadio,
    VRadioButtons,
    VCoords,
    VDatetime,
    VAutocomplete,
    VAutocompleteList,
    VStockOrderChangeStatus,
    VButton,
    VSubmit,
    SpinnerIqos,
    Page,
    Card,
    Tabs,
    Alert,
    List,
    Header,
    Child,
    ChartWidget,
    VTable,
    PhoneValidation,
    LendingKitEdit
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js